import {WidgetType} from '@codemirror/view'
import {parseEntities} from 'parse-entities'

/** Renders a parsed HTML character reference. */
export class CharacterReferenceWidget extends WidgetType {
  #reference: string

  constructor(reference: string) {
    super()
    this.#reference = reference
  }

  toDOM() {
    const span = document.createElement('span')
    span.textContent = parseEntities(this.#reference)
    return span
  }

  override eq(widget: CharacterReferenceWidget) {
    return widget.#reference === this.#reference
  }
}
